import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "9",
      height: "9",
      x: "4",
      y: "4",
      rx: "2"
    }, null, -1 /* CACHED */),
    _createElementVNode("circle", {
      cx: "21.5",
      cy: "8.5",
      r: "4.5"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "m8.5 17 4.5 4.5L8.5 26 4 21.5z" }, null, -1 /* CACHED */),
    _createElementVNode("rect", {
      width: "9",
      height: "9",
      x: "17",
      y: "17",
      rx: "2"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }